import { varsFromServer } from 'client/javascript/client_side_injection_vars';
import { get } from 'shared/util/helpers';
import IntlMessageFormat from 'intl-messageformat';

export function __(key, context) {
  const message = get(varsFromServer.clientStrings || {}, key);
  if (!message) {
    // eslint-disable-next-line
    console.log('🛑 Missing message for key:', key);
    return key;
  }
  if (context) {
    return message.replace(/\{+([^}]+)\}+/g, (match, p1) => escape(context[p1]));
  }
  return message;
}

const messageStore = {};

// Uses messageformat syntax for smart international pluralization
// Ex: "Viewing {count, plural, one {# WeWork building.} other {# WeWork buildings.}}"
export function __mf(key, context) {
  const message = get(varsFromServer.clientStrings || {}, key);
  if (!message) {
    // eslint-disable-next-line
    console.log('🛑 Missing message for key:', key);
    return key;
  }

  if (!messageStore[key]) {
    messageStore[key] = new IntlMessageFormat(message);
  }

  try {
    return messageStore[key].format(context);
  } catch (e) {
    // eslint-disable-next-line
    console.log('Failed to parse message for key:', key);
  }
}

// not sure about other chars, first get "<>" in.
/* eslint-disable */
const entityMap = {
  // '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;'
  // '"': '&quot;',
  // "'": '&#39;',
  // '/': '&#x2F;',
};
/* eslint-enable */

function escape(data) {
  if (typeof data === 'string') {
    // return data.replace(/[&<>"'\/]/g, s => entityMap[s]);
    return data.replace(/[<>]/g, s => entityMap[s]);
  }

  return data === undefined ? '' : data;
}
